export const HOTEL_DISTANCE_SLIDER_MAX_MILES = 50;
export const DEFAULT_HOTEL_DISTANCE_MILES = 10;

function collectDistanceNumbers(value: unknown): number[] {
  if (typeof value === 'number' && Number.isFinite(value)) {
    return [value];
  }

  if (typeof value === 'string' && value.trim() !== '') {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? [parsed] : [];
  }

  if (Array.isArray(value)) {
    return value.flatMap((item) => collectDistanceNumbers(item));
  }

  return [];
}

/** Max radius in miles for POST /property/search (`filters.distance`). */
export function toHotelDistanceMiles(
  value: unknown,
  fallback = DEFAULT_HOTEL_DISTANCE_MILES
): number {
  const numbers = collectDistanceNumbers(value);
  if (!numbers.length) return fallback;

  const maxDistance = Math.max(...numbers);
  if (!Number.isFinite(maxDistance) || maxDistance < 0) return fallback;
  return maxDistance;
}

/** Single-thumb slider value: `[maxMiles]`. */
export function toHotelDistanceSliderValue(
  value: unknown,
  fallback = DEFAULT_HOTEL_DISTANCE_MILES
): [number] {
  const miles = Math.min(
    HOTEL_DISTANCE_SLIDER_MAX_MILES,
    toHotelDistanceMiles(value, fallback)
  );
  return [miles];
}

export function hotelDistanceLabel(value: unknown): string {
  return `Within ${toHotelDistanceMiles(value)} mi`;
}
